var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}),_vm._v(" "),_vm._t("default",function(){return [_vm._v("Loading...")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }